import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExtractAssetsFromResource(
    $customerId: ID!
    $contentType: ProjectContentTypeEnum!
    $resourceId: ID!
  ) {
    extractAssetsFromResource(
      customerId: $customerId
      contentType: $contentType
      resourceId: $resourceId
    ) {
      id
    }
  }
`;

export const extractAssetsFromResource = async ({ customerId, contentType, resourceId }) => {
  const variables = {
    customerId,
    contentType,
    resourceId,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
